<template lang="pug">
system-tabs(section="/system/tickets")
    el-card.contains-table(shadow="always")
        time-entry-list(scope="system")
</template>

<script>
import SystemTabs from '@/views/system/Partials/Tabs';
import TimeEntryList from '@/extensions/tickets/views/TimeEntryList';

/**
 * Chrome only. `/system/tickets/times` is a top-level route (like the gantt and
 * the project list), so it renders its own tab bar, marked on Tickets — booked
 * time belongs to the ticket section rather than beside it.
 */
export default {
    name: 'SystemTimeEntryList',
    components: {
        SystemTabs,
        'time-entry-list': TimeEntryList,
    },
};
</script>
